import type { ApiType, DataSource } from "../types";
import { cls } from "../format";

const apiToneClass = (t: string) => {
  const v = t.toUpperCase();
  if (v === "PAN") return "tag-pan";
  if (v === "CRIF") return "tag-crif";
  if (v === "UAN") return "tag-uan";
  return "tag-default";
};

export const ApiTypeTag = ({ type }: { type: ApiType | string | null | undefined }) => {
  const v = (type || "?").toUpperCase();
  return <span className={cls("tag", apiToneClass(v))}>{v}</span>;
};

export const DataSourceBadge = ({ source }: { source: DataSource }) => {
  if (!source) return <span className="badge badge-gray">—</span>;
  const map: Record<NonNullable<DataSource>, string> = {
    CACHE: "badge-green",
    THIRD_PARTY: "badge-yellow",
    MOCK: "badge-cyan",
  };
  return <span className={cls("badge", map[source])}>{source}</span>;
};

export const StatusBadge = ({ code }: { code: number }) => {
  const tone =
    code >= 500
      ? "badge-red"
      : code >= 400
        ? "badge-yellow"
        : code >= 300
          ? "badge-cyan"
          : code >= 200
            ? "badge-green"
            : "badge-gray";
  return <span className={cls("badge", tone)}>{code || "—"}</span>;
};

export const CircuitBadge = ({
  state,
}: {
  state: "CLOSED" | "OPEN" | "HALF_OPEN";
}) => {
  const tone =
    state === "OPEN"
      ? "badge-red"
      : state === "HALF_OPEN"
        ? "badge-yellow"
        : "badge-green";
  return <span className={cls("badge", tone)}>{state}</span>;
};
